var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-header"},[_c('div',{staticClass:"head-title"},[_vm._v("钢铁退火炉3D可视化数字孪生系统")]),_c('div',{staticClass:"head-time"},[_c('div',{staticClass:"nowDate"},[_vm._v(_vm._s(_vm.nowDate))]),_c('div',{staticClass:"nowTime"},[_vm._v(_vm._s(_vm.nowTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }